import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=2b3c09de&scoped=true&lang=pug&"
import script from "./ProductPrice.vue?vue&type=script&lang=ts&"
export * from "./ProductPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=2b3c09de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c09de",
  null
  
)

export default component.exports